import { Component, Input, OnInit } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'ngx-file-upload-modal',
  templateUrl: './file-upload-modal.component.html',
  styleUrls: ['./file-upload-modal.component.scss']
})
export class FileUploadModalComponent implements OnInit {
  selectedFile : File | null = null;
  uploadFileForm = new FormGroup({
    // product: new FormControl('', Validators.required),
    file: new FormControl(null, Validators.required),
  });

  @Input() message: string;
  @Input() acceptType: string;

  constructor(protected ref: NbDialogRef<FileUploadModalComponent>) { }
  ngOnInit(): void {
  }

  // Fonction appelée lorsque le fichier est sélectionné
  onFileChange(files :any) {
    this.selectedFile = files[0]; // Récupère le premier fichier sélectionné
  }

  // Fonction appelée lorsque le formulaire est soumis
  submit() {
    if (this.uploadFileForm.valid && this.selectedFile) {
      this.ref.close(this.selectedFile)
    }
  }

  cancel() {
    this.ref.close();
  }
}
